import { useTranslation } from 'react-i18next';

import type { DepartmentRow } from '../../types';
import { Mono } from '@/shared/ui/atoms/Mono';
import { DataTable, type Column } from '@/shared/ui/organisms/DataTable';

type Props = { rows: DepartmentRow[] };

/**
 * Work per department: only approved completions and the time of reportable tasks count; completions waiting
 * for review are shown apart.
 */
export function DepartmentTable({ rows }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'insights.departments' });
  const columns: Column<DepartmentRow>[] = [
    {
      key: 'name',
      header: t('department'),
      render: (r) => (
        <div>
          <div>{r.name ?? t('none')}</div>
          {r.leadName ? <div className="f-users__email">{t('lead', { name: r.leadName })}</div> : null}
        </div>
      )
    },
    { key: 'activeProjects', header: t('projects'), mono: true, render: (r) => r.activeProjects },
    { key: 'members', header: t('members'), mono: true, render: (r) => r.members },
    { key: 'completedTasks', header: t('completed'), mono: true, render: (r) => r.completedTasks },
    { key: 'pendingCompletions', header: t('pending'), render: (r) => <Mono>{r.pendingCompletions}</Mono> },
    { key: 'loggedHours', header: t('hours'), mono: true, render: (r) => r.loggedHours.toFixed(1) }
  ];
  return <DataTable columns={columns} rows={rows} rowKey={(r) => r.departmentId ?? 'none'} empty={t('empty')} dense />;
}
